import {
    IonPage, IonContent, IonAlert,
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import Script from "react-load-script";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";
import {bindPhoneQuery, getUserInfo, ProtectDenyUserByToken, sendSmsCodeByToken} from "./Service";
import cookieUtil from "../../../../utils/cookieUtil";


class AccountLost extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            showNoticeTip: false,
            djs: '',
            showGreyBackGround: false,
            stepTip: 0,
            token: null,
            userInfo: {},
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)


    componentDidMount() {
        this.queryUserInfo();
    }

    queryUserInfo = () => {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")});
            // //先从cookie缓存里取
            if (cookieUtil.has("userInfo")) {
                let userInfoJson = JSON.parse(cookieUtil.get("userInfo"))
                let userInfo = {
                    nickName: userInfoJson.nickName,
                    verified: userInfoJson.verified,
                    idNo: userInfoJson.idNo,
                    realName: userInfoJson.realName,
                }
                this.setState({userInfo: userInfo});
                return;
            }
            let param = {
                "access_token": cookieUtil.get("access_token")
            }
            getUserInfo(param).then(res => {
                if (res.code === '10000') {
                    this.setState({userInfo: res.data});
                    cookieUtil.putExpire("userInfo", JSON.stringify(res.data))
                }
            }).catch(err => {
                console.log(err);
            });
        } else {
            this.setState({
                isShowTip: true,
                showTipMsg: "请勿非法访问"
            })
        }
    }

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }
    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        this.setState({
            phoneTip: phoneTip,
        })

    };

    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }

        this.setState({
            code: e,
            codeTip: codeTip
        })
    }

    QuerybindPhone = () => {
        const {token} = this.state;

        const params = {
            'access_token': token

        };
        bindPhoneQuery(params).then(ret => {
            if (ret.code === '10000') {
                if (ret.data.flag === 1) {
                    this.setState({
                        phone: ret.data.phone,
                        stepTip: 2,
                        showGreyBackGround: true
                    })
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: "该账号未绑定手机号"
                    })
                }
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
        });
    }

    reportLostAccount = () => {
        const {account, code, codeTip, token} = this.state;

        if (codeTip != 1) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的验证码'
            })
            return;
        }

        if (token == null) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请勿非法操作'
            })
            return;
        }

        let param = {
            protectType: 2,
            accounts: account,
            smsCode: code,
            sType: 1,
            access_token: token,
        }
        ProtectDenyUserByToken(param).then(ret => {
            if (ret.code === '10000') {
                this.setState({
                    stepTip: 3,
                    showGreyBackGround: true,
                })
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: '挂失失败【' + ret.msg + '】'
                })
            }
        }).catch(err => {
            this.setState({
                isShowTip: true,
                showTipMsg: '失败(' + err + ')'
            })
        });

    }

    showView = () => {
        const {phone, token, phoneTip} = this.state;
        //console.log(phoneTip);
        const _that = this;
        if (token == null) {
            _that.setState({
                isShowTip: true,
                showTipMsg: '非法操作'
            })
            return;
        } else {
            // eslint-disable-next-line
            let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
                console.log("res============" + JSON.stringify(res));
                // res（用户主动关闭验证码）= {ret: 2, ticket: null}
                // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
                if (res.ret === 0) {
                    const urlParms = {
                        'phone': phone,
                        'ticket': res.ticket,
                        'randStr': res.randstr,
                        'stype': 11,
                        'access_token': token,
                    }
                    sendSmsCodeByToken(urlParms).then(ret => {
                        if (ret.code === '10000') {
                            captcha1.destroy();
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: '验证码已发送，请注意查收'
                            })
                            let djs = 60;
                            let aa = '';
                            let timeout = setInterval(function () {
                                djs--;
                                aa = (djs === 0) ? '获取验证码' : (djs + 's');
                                if (djs === 0 || djs < 0) {
                                    clearInterval(timeout);
                                }
                                _that.setState({djs: djs, getCodeMsg: aa})
                            }, 999)
                        } else {
                            alert(ret.msg);
                            captcha1.destroy();
                        }
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
            }, {bizState: 'RSCNO7XFNGG9r6xB'});
            captcha1.show(); // 显示验证码
        }
    }


    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    render() {
        const {phone, showGreyBackGround, stepTip, getCodeMsg, userInfo} = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className={"phone_top pr mb56 border-bottom-e6"}>
                            <div className="top_title">账号挂失</div>
                        </div>
                        <div className="cont_kf">
                            <div className="gs_cont">
                                <p className="fs17"><span>用户名：</span>{userInfo.nickName}</p>
                                <p className="fs17"><span>选择操作途径：</span>通过验证手机</p>
                            </div>
                            <a className="btn_kf mt60" onClick={() => this.QuerybindPhone()}>下一步</a>
                        </div>
                        {/*<!-------------------------灰色透明层--------------------->*/}
                        <div className={showGreyBackGround ? "greybackground" : "dn"}></div>
                        {/*<!-------------------------账号挂失 tc--------------------->*/}
                        <div className={stepTip === 2 ? "tc02" : "dn"}>
                            <div className="tc_bg">
                                <a className="close"
                                   onClick={() => this.setState({stepTip: 1, showGreyBackGround: false})}>关闭</a>
                                <div className="tc_cont pr">
                                    <div className="tc_title">账号挂失</div>
                                    <div className="point2 pa dn"><p>短信验证码不匹配</p></div>
                                    <div className="tc_cont_tex">
                                        <p>正在使用绑定手机<em>{phone}</em>账号挂失</p>
                                        <Script
                                            url={captchaUrl()}
                                            onError={this.handleScriptError}
                                            onLoad={this.handleScriptLoad}
                                        />
                                        <div className="tc_input clearfix">
                                            <span>验证码</span>
                                            <input type="text" className="input-tex2" placeholder="请输入验证码"
                                                   onChange={e => this.setCode(e.target.value)}/>
                                            <input type="button" onClick={e => this.showView()}
                                                   className="input-button-kefu" value={getCodeMsg}/>
                                        </div>
                                        <a onClick={() => this.reportLostAccount()} className="btn m50">下一步</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<!------------------------- 账号挂失 tc--------------------->*/}
                        <div className={stepTip === 3 ? "tc02" : "dn"}>
                            <div className="tc_bg">
                                <a className="close"
                                   onClick={() => this.setState({stepTip: 1, showGreyBackGround: false})}>关闭</a>
                                <div className="tc_cont pr">
                                    <div className="tc_title">挂失成功</div>
                                    <div className="successful_icon"><img
                                        src={require("../../../images/member/kefu/phone/successful_icon.png")}/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(AccountLost);
